import React from "react";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";

import componentsStyle
	from "assets/jss/material-kit-pro-react/views/presentationSections/componentsStyle.js";

import Rose from "../../components/Typography/Rose";
import intl from 'react-intl-universal';


const useStyles = makeStyles(componentsStyle);

export default function WelcomeAnimation() {
	const classes = useStyles();
	return (
		<div style={{width: '100%', backgroundColor: '#e5e5e5', paddingTop: '100px'}}>

			<div id={'WelcomeAnimation'}>
				<div className={classes.container} style={{backgroundColor: '#e5e5e5'}}>
					<GridContainer justify="center">
						<GridItem xs={12} sm={12} md={5} lg={5}  >
							<h3 className={classes.title}>{intl.get('more_info')}</h3>
							<h5 className={classes.description} style={{color: '#000'}}>
								{intl.get('more_info_1')}<Rose><a href={'/about'}>{intl.get('more_info_2')}</a></Rose>?
							</h5>
						</GridItem>
						<GridItem xs={12} sm={12} md={6} lg={6} className={classes.mlAuto}>
							<div className={classes.imageContainer}>
								<img
									src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/laptop-basics.png'}
									alt=""
									className={classes.componentsMacbook}
								/>
								<img
									src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/welcome_account.png'}
									alt=""
									className={classes.shoppingCart}
								/>


								<a href="https://github.com/clwater/LeetCodeAllAnimation/stargazers"
								   target={"_blank"}>
									<img alt="GitHub stars"
										 src="https://img.shields.io/github/stars/clwater/LeetCodeAllAnimation"
										 className={classes.shareButton}
									/>
								</a>

								<img
									src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/welcome_price.png'}
									alt=""
									className={classes.cardImage}
								/>

								<img
									src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/robin-base-logo-white.png'}
									alt=""
									className={classes.repostImage}
								/>
							</div>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>

	);
}
